import React from "react";
import { Bar } from "react-chartjs-2";
import { Chart as ChartJS, BarElement, CategoryScale, LinearScale, Tooltip, Legend } from "chart.js";

ChartJS.register(BarElement, CategoryScale, LinearScale, Tooltip, Legend);

const BarChart = ({ chartList }) => {
  const chart = chartList?.data?.map((item) =>
    chartList?.data?.length === 12 ? item?.month_name?.slice(0, 3) : item?.month_name
  );
  const salesData = chartList?.data?.map((item) => item?.total_order_values);

  const data = {
    labels: chart,
    datasets: [
      {
        label: "Sales",
        data: salesData,
        backgroundColor: "rgba(75, 192, 192, 0.6)",
        borderColor: "rgba(75, 192, 192, 1)",
        borderWidth: 1,
        borderRadius: 4,
        barThickness: 30,
      },
    ],
  };

  const options = {
    responsive: true,
    plugins: {
      legend: {
        position: "top",
      },
      tooltip: {
        callbacks: {
          label: function (tooltipItem) {
            return `Sales: ${tooltipItem.raw}`;
          },
        },
      },
    },
    scales: {
      y: {
        beginAtZero: true,
      },
    },
  };

  return (
    <div className="w-full p-4 bg-white rounded-lg shadow-md">
      <h3 className="text-2xl font-normal mb-3 text-black">
        Monthly <span className="text-red-600 font-bold">Sales</span>
      </h3>
      <hr className="w-full border-1 border-slate-500 mb-4" />
      <Bar data={data} options={options} />
    </div>
  );
};

export default BarChart;
